module.exports = __webpack_public_path__ + "static/media/8.c5c1e1d3.jpg";